/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import MenuItem from './menu-item';

export * from './menu-item-props';

/**
 * Exporting Menu class.
 */
export { MenuItem };
